import { ViewTitleProps } from '@diligentcorp/heracles-view-title';
import { LoadingButtonProps } from '@issuemanager/apps/client/components';
import React, { createContext, useCallback, useContext, useState } from 'react';

export type AppHeaderPrimaryButtonProps = LoadingButtonProps & {
  'data-testid'?: string;
};

export interface AppHeaderProps {
  viewTitle: ViewTitleProps;
  buttons?: AppHeaderPrimaryButtonProps[];
  chip?: React.ReactNode;
  bottomSection?: React.ReactNode;
}

const defaultHeaderProps: AppHeaderProps = {
  viewTitle: { title: '' },
  buttons: [],
  chip: undefined,
  bottomSection: null,
};

const HeaderPropsContext = createContext<AppHeaderProps | null>(null);
type SetHeaderProps = (props: AppHeaderProps) => void;

const SetHeaderPropsContext = createContext<SetHeaderProps | null>(null);

export function HeaderProvider({
  children,
}: {
  children: React.ReactNode;
}): React.ReactElement {
  const [headerProps, setHeaderPropsState] =
    useState<AppHeaderProps>(defaultHeaderProps);
  const setHeaderProps = useCallback((props: AppHeaderProps): void => {
    setHeaderPropsState(props);
  }, []);

  return (
    <SetHeaderPropsContext.Provider value={setHeaderProps}>
      <HeaderPropsContext.Provider value={headerProps}>
        {children}
      </HeaderPropsContext.Provider>
    </SetHeaderPropsContext.Provider>
  );
}

export function useHeaderProps(): AppHeaderProps {
  const context = useContext(HeaderPropsContext);
  if (!context) {
    throw new Error('useHeaderProps must be used within HeaderProvider');
  }
  return context;
}

export function useSetHeaderProps(): (props: AppHeaderProps) => void {
  const context = useContext(SetHeaderPropsContext);
  if (!context) {
    throw new Error('useSetHeaderProps must be used within HeaderProvider');
  }
  return context;
}
